module.exports = __webpack_public_path__ + "static/img/sp_3.6103c14.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/sp_3.png
// module id = 1070
// module chunks = 1